@let campaignContent = activeSection();
@let campaignEvent = eventObject();
@if (campaignContent && campaignEvent) {
  <div class="content-layout" [brightsideWebFb]="campaignEvent">
    <bw-action-article-legacy style="--action-article-max-height: 100%">
      <div header-actions>
        <ui-nav-exit-back
          [trackingDetail]="campaignEvent"
          [skipActionEmit]="true"
        ></ui-nav-exit-back>
      </div>
      @if (campaignHeaderImg()) {
        <div pre-title class="mb-sm">
          <img src="{{ campaignHeaderImg() }}" alt="Campaign Header Image" class="header-img">
        </div>
      }
      <div header-title>
        <typography-legacy title-large color="var(--primary-text)">
          {{ campaignContent.title | translate }}
        </typography-legacy>
      </div>
      <div content-section>
        <bw-paragraph-legacy><div [innerHTML]="campaignContent.desc | translate | lineBreaks"></div></bw-paragraph-legacy>
      </div>
      <div footer-actions>
        <button
          bw-button-legacy
          [brightsideWebFb]="campaignEvent"
          (click)="handleCtaClick(campaignContent.cta1)"
          >
          {{ campaignContent.cta1.copyKey | translate }}
        </button>
        @if (campaignContent.cta2) {
          <button
            bw-link-button-legacy
            [brightsideWebFb]="campaignEvent"
            [secondaryCta]="true"
            (click)="handleCtaClick(campaignContent.cta2)"
          >
            {{ campaignContent.cta2.copyKey | translate }}
          </button>
        }
      </div>

    </bw-action-article-legacy>
  </div>
}
